<template>
  <div>
    <div class="box" style="border-top-left-radius:0">
      <admin-box-item :title="`${targetKorName} 필터 추가 및 설정`"
                      :bottomSubtitle="subtitle">
        <div class="flex" style="flex-wrap: wrap">
          <div class="lp-form-type"
               :class="{'selected':selectedFilterItem.id===item.id}"
               v-for="(item, idx) in value.filter_set_list" :key="'filter-set-'+idx"
               @click="clickFormType(item, 'filter', idx)">
            <input class="input lp-form-type-input"
                   :value="item.name"
                   @input="e => inputLabel(e, 'filter', item)"
                   type="text"
                   maxlength="15">
            <i class="material-icons lp-form-close"
               @click.stop.prevent="deleteForm('filter', idx)"
               v-if="selectedFilterItem.id===item.id && selectedFilterItem.id!==1">close</i>
          </div>
          <div class="lp-form-add" @click="addFilterForm">+</div>
        </div>
      </admin-box-item>
    </div>

    <div class="box" v-if="value.filter_set_list.length > 0">
      <admin-box-item :title="`${targetKorName} 필터: ${selectedFilterItem.name}`"
                      :useTab="false"
                      :bottomSubtitle="`서비스에서 사용할 ${targetKorName} 필터를 직접 설정할 수 있습니다.\n` +
                              `* '${targetKorName} 맞춤 DB' 구매 시 다양한 기준 값으로 ${targetKorName} 필터링이 가능합니다.`">
        <div slot="header-right-spot">
          <div class="btn-group-justify-end" style="margin:0;position:absolute;top:0;right:4rem">
            <button class="button small" @click="addCopyForm('filter')" v-if="value.filter_set_list.length > 0">복제
            </button>
          </div>
        </div>
        <draggable :list="value.custom_filter_set.data" :options="{group:'item', ghostClass:'ghost'}" class="dragArea">
          <template v-if="value.custom_filter_set.data.length > 0">
            <div class="columns is-multiline"
                style="margin:0; border-bottom: 1px solid #e5e5e5; padding: 12px 0"
                v-for="(item, idx) in value.custom_filter_set.data" :key="'filter-set'+idx">
              <div style="line-height: 5rem; color: #bababa">
                <admin-form-item>
                  <i class="material-icons lp-drag-indicator">
                    drag_indicator
                  </i>
                </admin-form-item>
              </div>
              <div class="column is-2">
                <admin-form-item :label="item.is_param? '추가 필터명': '기본 필터명'">
                  <input class="input"
                        :value="item.label"
                        @input="e => item.label = e.target.value"
                        type="text" maxlength="30">
                </admin-form-item>
              </div>
              <div class="column is-2" style="width:268px">
                <admin-form-item label="필터 스타일"
                                :tip="'프론트에 노출되는 필터의 스타일을 선택할 수 있습니다.\n' +
                          '예)가격 범위 검색 필터 - 숫자범위스타일'">
                  <lp-img-drop-down @onSelect="res=> selectFilterStyle(res, item, idx)"
                                    :selectVal="item.type"
                                    :data.sync="inputTypeList"
                                    value_name="input_type"
                                    listAlign="center"></lp-img-drop-down>
                </admin-form-item>

                <div class="columns is-multiline"
                    v-if="item.type==='number_range' && item.keyword==='params__value_linear'">
                  <div class="column is-6" v-if="item.options.min_label!==undefined">
                    <admin-form-item label="최소 레이블">
                      <input class="input"
                            v-model="item.options.min_label">
                    </admin-form-item>
                    <admin-form-item label="최소값">
                      <input class="input"
                            type="number"
                            v-model="item.options.min">
                    </admin-form-item>
                  </div>
                  <div class="column is-6" v-if="item.options.max_label!==undefined">
                    <admin-form-item label="최대 레이블">
                      <input class="input"
                            v-model="item.options.max_label">
                    </admin-form-item>
                    <admin-form-item label="최대값">
                      <input class="input"
                            type="number"
                            v-model="item.options.max">
                    </admin-form-item>
                  </div>
                </div>

                <div class="columns is-multiline" v-else-if="item.type.indexOf('number_range')>-1">
                  <div class="column is-6">
                    <admin-form-item label="최소값">
                      <input class="input"
                            type="number"
                            v-model="item.options.min">
                    </admin-form-item>
                  </div>
                  <div class="column is-6">
                    <admin-form-item label="최대값">
                      <input class="input"
                            type="number"
                            v-model="item.options.max">
                    </admin-form-item>
                  </div>
                </div>
              </div>
              <div class="column is-3">
                <admin-form-item :label="`매칭시킬 DB 항목`"
                                :tip="'필터와 상품DB 값을 매핑하여 등록할 수 있습니다. 단, 필터 스타일과 DB 타입이 동일한 경우에만 매핑이 가능합니다.\n' +
                            '예) 필터 스타일이 숫자 범위일 경우, 숫자 타임의 DB만 매칭 가능'">
                  <div>
                  <span class="select">
                    <select class="match-db" :value="mappingParam(item, 'filter')" @change="e => selectMatchingDB(e, item)">
                      <template v-for="(dbitem,idx) in targetParamList">
                        <option :key="'dbitem-'+idx" :value="mappingParamValue(dbitem)"
                                v-if="isFilterTrueType(item, dbitem)">{{ dbitem.name }}</option>
                      </template>
                    </select>
                  </span>
                  </div>
                </admin-form-item>
              </div>
              <div class="column is-2">
                <admin-form-item label="사용여부">
                  <toggle-button @change="e=> item.is_active = e.value"
                                :value="item.is_active"
                                :sync="true"
                                class="changed-font"
                                :width="70"
                                :height="24"></toggle-button>
                </admin-form-item>
              </div>
              <div class="column is-2">
                <admin-form-item>
                  <button class="button text-primary small"
                          style="margin-top: 20px"
                          @click="deleteCustomFilterItem(idx, 'filter')">삭제
                  </button>
                </admin-form-item>
              </div>
              <div class="column is-2">
                <admin-form-item>

                </admin-form-item>
              </div>
            </div>
          </template>
        </draggable>
        <div class="columns is-multiline"
             style="margin:0">
          <div class="column is-full">
            <span @click="addFilter" class="add-filter">+ 필터추가하기</span>
          </div>
        </div>
      </admin-box-item>
    </div>
  </div>
</template>
<script>
  import draggable from 'vuedraggable'
  import FilterSettingMixin from "../../../../mixins/FilterSettingMixin";
  import LpImgDropDown from "../../../module/common/LpImgDropDown";

  export default {
    name: "FilterSettingComp",
    components: {LpImgDropDown, draggable},
    props: {
      value: {
        type: Object
      },
      inputTypeList: {
        type: Array
      },
      targetParamList: {
        type: Array
      },
      target: {
        type: String
      }
    },
    mixins: [
      FilterSettingMixin
    ],
    data() {
      return {
        selectedFilterItem: {
          id: 0,
          name: ''
        },
      }
    },
    computed: {
      subtitle() {
        let text = '';
        if(this.target==='product') text = `'카테고리 필터셋' 플러그인 구매 시, 상품 페이지별로 다른 필터를 적용할 수 있습니다. 예) 여행상품 안내 플랫폼일 경우, 국내여행상품과 해외여행상품의 검색 필터를 다르게 설정`
        return text;
      },
      targetKorName() {
        return this.target==='product' ? '상품' : '공간 상품'
      }
    },
    methods: {
      // setfilter detail 가져오기
      init(){
        if( this.value.filter_set_list.length>0 ){
          let item = this.value.filter_set_list[0];
          this.selectedFilterItem.id = item.id;
          this.selectedFilterItem.name = item.name;
          this.getFilterSet();
        }
        else {
          this.value.custom_filter_set = {
            id: 0,
            name: '',
            target: this.target,
            data: []
          };
          this.value.custom_filter_set.data = this.filterSetData();
          this.value.filter_set_list = [];
          this.value.filter_set_list.push(this.selectedFilterItem);
        }
      },
      getFilterSet() {
        if(!this.selectedFilterItem.id) return;
        this.$axios.get(this.getUrl('service/set/filter/' + this.selectedFilterItem.id)).then(res=>{
          if(res.status===200) {
            res.data.data.forEach(item => {
              if (item.keyword === 'price__price') {
                item.options.unit = '원';
              }
            })
            this.value.custom_filter_set = res.data;
          }
        })
      },
      addFilterForm() {
        if(this.value.filter_set_list.length===0){
          this.value.custom_filter_set.data = this.filterSetData();
        }
        this.value.custom_filter_set.id = 0;
        this.value.custom_filter_set.name = '';
        this.value.custom_filter_set.target = this.target;
        this.value.filter_set_list.push({ name: '', id: 0 });
      },

      selectFilterStyle(res, item, idx) {
        item.type = res.input_type;
        if(item.type.indexOf('number_range')>-1) {
          item.options = {
            min: 0,
            max: 1000,
            unit: ''
          };
        }
        item.keyword = '';
        item.param_name = '';
        setTimeout(()=>{
          let docs = document.getElementsByClassName('match-db')
          docs[idx].value = ''
        },100)
      },
      addFilter(){
        let item = {
          label: '',
          is_param: true,
          keyword: '',
          // 매칭시킬 상품 파람 아이디
          param_id: '',
          param_name: '',
          type: 'text',
          is_active: false,
          set: []
        }
        this.value.custom_filter_set.data.push(item);
      },
      // 데이터 없을 경우 초기값
      filterSetData() {
        if(this.target==='product') {
          return [
            {
              set: [
                {
                  value: "",
                  keyword: "price__price",
                  operator: "__gte"
                },
                {
                  value: "",
                  keyword: "price__price",
                  operator: "__lte"
                }
              ],
              type: "number_range",
              label: "가격",
              keyword: "price__price",
              options: {
                max: 1000000000,
                min: 0,
                unit: "원"
              },
              is_param: false,
              param_id: "",
              is_active: false,
              param_name: "가격"
            },
            {
              set: [
                {
                  value: "",
                  keyword: "address",
                  operator: "__sido__name"
                },
                {
                  value: "",
                  keyword: "address",
                  operator: "__sigungu__name"
                }
              ],
              type: "address",
              label: "지역",
              keyword: "address",
              is_param: false,
              param_id: "",
              is_active: false,
              param_name: "지역"
            },
            {
              set: [
                {
                  value: "",
                  keyword: "category",
                  operator: "1_id"
                },
                {
                  value: "",
                  keyword: "category",
                  operator: "2_id"
                },
                {
                  value: "",
                  keyword: "category",
                  operator: "3_id"
                },
              ],
              type: "category",
              label: "카테고리",
              keyword: "category",
              is_param: false,
              param_id: "",
              is_active: false,
              param_name: "카테고리"
            }
          ]
        } else {
          return [
            {
              set: [
                {
                  value: "",
                  keyword: "products__price__price",
                  operator: "__gte"
                },
                {
                  value: "",
                  keyword: "products__price__price",
                  operator: "__lte"
                }
              ],
              type: "number_range",
              label: "가격",
              keyword: "products__price__price",
              options: {
                max: 1000000000,
                min: 0,
                unit: "원"
              },
              is_param: false,
              param_id: "",
              is_active: false,
              param_name: "가격"
            },
            {
              set: [
                {
                  value: "",
                  keyword: "address",
                  operator: "__sido__name"
                },
                {
                  value: "",
                  keyword: "address",
                  operator: "__sigungu__name"
                }
              ],
              type: "address",
              label: "지역",
              keyword: "address",
              is_param: false,
              param_id: "",
              is_active: false,
              param_name: "지역"
            },
            {
              set: [
                {
                  value: "",
                  keyword: "category",
                  operator: "1_id"
                },
                {
                  value: "",
                  keyword: "category",
                  operator: "2_id"
                },
                {
                  value: "",
                  keyword: "category",
                  operator: "3_id"
                },
              ],
              type: "category",
              label: "카테고리",
              keyword: "products__category",
              is_param: false,
              param_id: "",
              is_active: false,
              param_name: "카테고리"
            }
          ]
        }
      }
    }
  }
</script>
<style lang="stylus" scoped>
  @import '~assets/css/lp_main'

  .lp-form-type
    border 1px solid #7a7a7a
    border-radius 3px
    cursor pointer
    margin-right 8px
    margin-bottom 2px
    position relative


  .selected
    color $primary
    border 1px solid $primary
    background-color unset

  .lp-form-add
    width 60px
    border 1px solid
    border-radius 3px
    padding 6px 8px
    text-align center
    margin-right 8px
    cursor pointer
    height 33.5px

  .lp-form-type-input
    border 0
    box-shadow unset
    cursor pointer

  .add-filter
    padding 12px 24px
    color $primary
    cursor pointer

  .lp-form-close
    position absolute
    right 2px
    top 5px
    font-size 1.5rem
</style>
